"use strict";

require("core-js/modules/es6.object.assign");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TwitterLogoIcon = void 0;

var _react = _interopRequireDefault(require("react"));

var _SVGIcon = require("../../SVGIcon");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var TwitterLogoIcon = function TwitterLogoIcon(props) {
  return _react["default"].createElement(_SVGIcon.SvgIcon, _extends({
    viewBox: "0 0 30 30"
  }, props), _react["default"].createElement("defs", null, _react["default"].createElement("path", {
    id: "a",
    d: "M0 0h30v30H0z"
  })), _react["default"].createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _react["default"].createElement("mask", {
    id: "b",
    fill: "#fff"
  }, _react["default"].createElement("use", {
    xlinkHref: "#a"
  })), _react["default"].createElement("path", {
    fill: "currentColor",
    d: "M22.53353 12.15607c.0072.15503.01035.31088.01035.46748 0 4.77817-3.63728 10.28843-10.28843 10.28843-2.04247 0-3.9426-.59866-5.54295-1.6242.28297.03337.57082.0501.86257.0501 1.69426 0 3.25328-.57795 4.49115-1.54793-1.58294-.0294-2.9178-1.0749-3.37807-2.51153.2202.04216.44678.06526.67972.06526.32993 0 .64958-.04455.95326-.1272-1.65443-.33158-2.90108-1.79363-2.90108-3.5451 0-.01583 0-.03098.00082-.04605.48735.27105 1.04468.4341 1.6377.45232-.97072-.64793-1.60912-1.75538-1.60912-3.00998 0-.66225.17888-1.28317.48975-1.8174 1.78327 2.1879 4.44818 3.62693 7.45343 3.77798-.06203-.26475-.09383-.54068-.09383-.82447 0-1.99635 1.61948-3.61576 3.61658-3.61576 1.03987 0 1.97962.43958 2.63947 1.14248.82365-.16222 1.59728-.46357 2.29605-.87772-.2703.84427-.84352 1.55265-1.59 2.00025.7314-.08746 1.4286-.2814 2.0766-.56926-.4842.7251-1.09793 1.36193-1.80397 1.8723zM15 0C6.71572 0 0 6.71572 0 15c0 8.28428 6.71572 15 15 15 8.28428 0 15-6.71572 15-15 0-8.28428-6.71572-15-15-15z",
    mask: "url(#b)"
  })));
};

exports.TwitterLogoIcon = TwitterLogoIcon;